import api from '../apiService';
import { populateFields, clearFields, disableSaveButton, createDebouncedMemoRequest } from '../utils';

const debounceSearch = createDebouncedMemoRequest(api.getData, 300);

export async function fetchCurrentClaimDirection(involvedField, claimDirectionField) {
    const involved = $('select[name="' + involvedField + '"]').val();
    if (!involved) {
        clearFields([claimDirectionField]);
        return;
    }

    disableSaveButton(true);

    const cacheKey = `${involvedField}-${claimDirectionField}-${involved}`;

    debounceSearch(cacheKey, `/api/app/backpack/fetch-involved-claim-direction`, {
        params: { involved_id: involved },
    }).then((data) => {
        if (data.claim_direction) {
            populateFields({ [claimDirectionField]: [data.claim_direction] });
        } else {
            populateFields({ [claimDirectionField]: [''] });
        }
    })
    .catch(() => {
        clearFields([claimDirectionField]);
    })
    .finally(() => {
        disableSaveButton(false);
    });
}
